import React, { useMemo, useState } from "react";
import { ErrorDialog } from "../../components/ui/notification";
import {
  getIncomeStatement,
  getMonthlyIncomeStatement,
} from "../../lib/incomeStatementData";
import { FinancialFilterBar } from "./Components/FinancialFilter";
import { useQuery } from "@tanstack/react-query";
import { FinancialReport } from "./Components/FinancialReport";

const FinancialComponent = ({ report }) => {
  const [dismissed, setDismissed] = useState(false);

  const [tick, setTick] = useState(0);

  const [monthly, setMonthly] = useState(true);

  const today = new Date().toISOString().split("T")[0];
  const oneYearAgo = useMemo(() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    return d.toISOString().split("T")[0];
  }, []);
  const firstOfMonth = useMemo(() => {
    const d = new Date();
    d.setDate(1);
    d.setMonth(d.getMonth() - 2);
    return d.toISOString().split("T")[0];
  }, []);

  const [startDate, setStartDate] = useState(firstOfMonth);
  const [endDate, setEndDate] = useState(today);

  const {
    data: incomeStData = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["income_statement", tick, startDate, endDate],
    queryFn: () => getIncomeStatement({ startDate, endDate }),
    staleTime: 1000 * 60 * 15,
  });

  const {
    data: monthlyIncomeStData = {},
    isLoadingMonthly,
    isErrorMonthly,
  } = useQuery({
    queryKey: ["monthly_income_statement", tick, startDate, endDate],
    queryFn: () => getMonthlyIncomeStatement({ startDate, endDate }),
    staleTime: 1000 * 60 * 15,
  });

  const queryErrors = useMemo(() => {
    const errors = [
      {
        key: "income_statement",
        label: "Income Statement",
        isError: isError,
        error: "Error Loading Income St Data",
      },
      {
        key: "monthly_income_statement",
        label: "Monthly Income Statement",
        isError: isErrorMonthly,
        error: "Error Loading Monthly Income St Data",
      },
    ];
    return errors
      .filter((e) => e.isError)
      .map((e) => ({
        key: e.key,
        message: `${e.error}`,
      }));
  }, [isError, isErrorMonthly]);

  return (
    <>
      {(isLoading || (isLoadingMonthly && monthly)) && (
        <div className="loading-div">
          <div className="spinner"></div>
        </div>
      )}

      <ErrorDialog
        errors={dismissed ? [] : queryErrors}
        onClose={() => setDismissed(true)}
      />

      <FinancialFilterBar
        report={report}
        today={today}
        oneYearAgo={oneYearAgo}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        monthly={monthly}
        setMonthly={setMonthly}
        onRefresh={() => setTick((t) => t + 1)}
      />

      <section className="pbi-canvas">
        <FinancialReport
          startDate={startDate}
          endDate={endDate}
          monthly={monthly}
          incomeStData={incomeStData}
          monthlyIncomeStData={monthlyIncomeStData}
        />
        {/* <FinancialReport
          startDate={startDate}
          endDate={endDate}
          monthly={monthly}
          incomeStData={incomeStData}
          monthlyIncomeStData={monthlyIncomeStData}
        /> */}
      </section>
    </>
  );
};

export default FinancialComponent;
